import { getListItem } from '@yme/components/FooterBottomMenu/helpers';
export function getPreparedCountryItems(items) {
    return items.map(getListItem);
}
export function getPreparedLanguageItems(languages) {
    return languages?.map((language) => ({
        value: language.code,
        label: language.name,
    }));
}
